import { postRequest } from './util';
var create = function (stationId, loadCarriers) {
    return postRequest("/stations/".concat(stationId, "/loadCarriers"), loadCarriers);
};
export default {
    create: create,
};
